module.exports = __webpack_public_path__ + "static/media/red_ponyville_arp.bf68f4e5.gif";